import React from "react";
import "./DatePickerFilter.scss";
import "../Filter.scss";
import { DatePicker, Space } from 'antd';

const DatePickerFilter = ({ title, startSpecialKey, endSpecialKey, temporaryFilterList, setTemporaryFilterList }) => {

  const disabledDate = (date, startOrEnd) => {
    if (startOrEnd === "start") {
      return (date && temporaryFilterList[endSpecialKey] &&date > temporaryFilterList[endSpecialKey])

    }else if (startOrEnd === "end") {
      return (date && temporaryFilterList[startSpecialKey] &&date < temporaryFilterList[startSpecialKey])
    }
  };


  const onChange = (value, startOrEnd) => {
    setTemporaryFilterList({
      ...temporaryFilterList,
      [startOrEnd === "start" ? startSpecialKey : endSpecialKey]: value
    })
  };

  return (
    <div className="Filter DatePickerFilter">
      <div className="title">
        {title}
      </div>
      <div className="DatePicker">
        <Space direction="horizontal" size={12} >
          <DatePicker value={temporaryFilterList[startSpecialKey]} placeholder="From" disabledDate={(date) => disabledDate(date, "start")} onChange={(value) => onChange(value, "start")}/>
          <DatePicker value={temporaryFilterList[endSpecialKey]} placeholder="To" disabledDate={(date) => disabledDate(date, "end")} onChange={(value) => onChange(value, "end")}/>
        </Space>
      </div>
    </div>
  )
};

export default DatePickerFilter;
